import Api from '@/services/Api'
import LocalStorage from '@/services/LocalStorageService'

const root = 'socket-server'
const clientRoot = () => `${LocalStorage.getClientPrefix()}/socket-server`

class SocketServerService {
  about () {
    return Api().get(`${root}/about`)
  }

  insert (item) {
    item.clientPrefix = LocalStorage.getClientPrefix()
    return Api().post(root, item)
  }

  update (item) {
    item.clientPrefix = LocalStorage.getClientPrefix()
    return Api().put(root, item)
  }

  findAll () {
    return Api().get(`${clientRoot()}`)
  }

  delete (name) {
    const url = `${clientRoot()}/${name}`
    return Api().delete(url)
  }

  findById (name) {
    const url = `${clientRoot()}/${name}`
    return Api().get(url)
  }
}

export default new SocketServerService()
